/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import { getEventType } from './EventTypes';
import { connect } from 'react-redux';
import fetchAdminUsers from '../../actions/reduxActions/adminUsers';
import moment from 'moment';
import {
    fetchLogs,
    resetFilters,
    updatePageNumber,
} from '../../actions/reduxActions/logs';
import 'react-day-picker/lib/style.css';
import PagedTable from '../PagedTable';
import 'react-selectize/themes/index.css';
import Pager from '../Pager';
import Table from '../Table';
import SyntaxHighlighter from '../generic/SyntaxHighlighter';
import Modal from '../generic/Modal';
import { formatJSONContent } from '../../utils/core';
import AuditLogsFilters, { humanizeAuditUser, PUBLIC_USER } from './AuditLogsFilters';
import '../../../css/audit-logs.less';

export const mapDispatchToProps = dispatch => ({
    getUsers: (authenticationToken, tenantId) => {
        dispatch(fetchAdminUsers(authenticationToken, tenantId));
    },
    resetFilters: (authenticationToken) => {
        dispatch(updatePageNumber(1));
        dispatch(resetFilters());
        dispatch(fetchLogs(authenticationToken));
    },
    getLogs: (authenticationToken) => {
        dispatch(fetchLogs(authenticationToken));
    },
    setPageNumber: (pageNumber) => {
        dispatch(updatePageNumber(pageNumber));
    },
});

const mapStateToProps = state => ({
    users: [PUBLIC_USER, ...state.user],
    logs: state.logs,
});

export const AuditLogs = ({
    authenticationToken,
    tenantId,
    users,
    logs,
    getUsers,
    resetFilters,
    getLogs,
    setPageNumber,
}) => {

    useEffect(() => {
        getUsers(authenticationToken, tenantId);
        resetFilters(authenticationToken);
    }, [authenticationToken, tenantId]);

    const [content, setContent] = useState(null);
    const [showContent, setShowContent] = useState(false);

    const getLogRecords = (nextPage) => {
        setPageNumber(nextPage);        
        getLogs(authenticationToken);
    };

    const onSelectItem = (item) => {
        setContent(JSON.stringify(item, null, '\t'));
        setShowContent(true);
    };

    const columns = [
        {
            renderHeader: () => 'Event Type',
            renderCell: ({ item }) => getEventType(item.type).name,
            size: '225px',
        },
        {
            renderHeader: () => 'Occurred At (UTC)',
            renderCell: ({ item }) => moment(item.occurredAt).utc().format('HH:mm:ss'),
            size: '150px',
        },
        {
            renderHeader: () => 'Actioned By',
            renderCell: ({ item }) => humanizeAuditUser(item.user),
            size: '400px',
        },
        {
            renderHeader: () => 'Flow',
            renderCell: ({ item }) => item.flow
                ? item.flow.developerName
                : null,
        },
        {
            renderHeader: () => 'Entries',
            renderCell: ({ item }) => (
                <button
                    className="link-emulate"
                    onClick={() => onSelectItem(item)}
                >
                    View
                </button>
            ),
            size: '75px',
        },
    ];

    return (
        <div className="admin-page">
            <h1>Auditing</h1>

            <AuditLogsFilters
                authenticationToken={authenticationToken}
                users={users}
                logs={logs}
            />

            {logs.isLoading || (logs.data.items && logs.data.items.length > 0) ? (
                <div className="table-wrapper">
                    <Table
                        className="table margin-top"
                        columns={columns}
                        items={logs.isLoading ? [] : logs.data.items}
                        isLoading={logs.isLoading}
                    />

                    <Pager
                        page={logs.isLoading ? 0 : logs.data._meta.page}
                        pageSize={logs.isLoading ? 0 : logs.data._meta.pageSize}
                        total={logs.isLoading ? 0 : logs.data._meta.total}
                        onPageClick={nextPage => getLogRecords(nextPage)}
                    />
                </div>) :
                <div className="table-no-results-message">No Results</div>
            }

            <Modal
                show={showContent}
                onHide={() => setShowContent(false)}
                title="Event Entry"
                renderBody={() => (
                    <SyntaxHighlighter
                        content={formatJSONContent(content)}
                        language="json"
                    />
                )}
                renderFooter={() => (
                    <div className="flex">
                        <div className="flex-child-right">
                            <button className="btn btn-sm btn-default" onClick={() => setShowContent(false)}>
                                Close
                            </button>
                        </div>
                    </div>
                )}
            />

        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(AuditLogs);
